import React from 'react';
import { Link } from 'react-router-dom';
import { Add } from '@mui/icons-material';
import { Box } from '@mui/material';

import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';
import { Page, Button } from '@occc-app/design-system';
import { useGetSitesSummaryQuery } from '@occc-app/dataAccessLayer/location/queries';

import SiteManagement from './SiteManagement';
import LocationsSummary from './LocationsSummary/LocationsSummary';

const PAGE_TITLE = 'Site Management';

const LocationListPage: React.FC = () => {
  const { error, loading, data } = useGetSitesSummaryQuery();
  const isUserPermittedToCreateLocation = useIsUserPermittedTo(Feature.LOCATION_CREATE);

  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      pageHeaderProps={{ title: PAGE_TITLE }}
      actions={
        isUserPermittedToCreateLocation && (
          <Box ml='auto'>
            <Button
              color='secondary'
              variant='contained'
              startIcon={<Add />}
              component={Link}
              to='create'
              role='button'
            >
              Add location
            </Button>
          </Box>
        )
      }
    >
      <LocationsSummary data={data} error={error} loading={loading} />
      <SiteManagement />
    </Page>
  );
};

export default LocationListPage;
